export function formatRichText(text: string): string {
    if (!text) return '';

    // Convert __text__ to <strong> tags
    text = text.replace(/__(.*?)__/g, '<strong>$1</strong>');

    // Convert \n to <br> tags
    text = text.replace(/\n/g, '<br>');

    // Convert [link](url) to <a href="url">link</a>
    text = text.replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2">$1</a>');

    return text;
}
